import { useNavigate, useLocation } from 'react-router-dom';
import { useLang } from '../context/LangContext';
import { scholarTitledName } from '../utils/api';

export default function MainNav({ scholars, categories }) {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const location = useLocation();
  const at = (path) => location.pathname === path || location.pathname.startsWith(path + '/') ? 'active' : '';
  const go = (path) => (e) => { e.preventDefault(); navigate(path); };

  const newBadge = { ar: 'جديد', en: 'New', ur: 'نیا' };

  // Causes submenu — fully translated
  const causesItems = [
    { emoji: '🇵🇸', key: 'nav.causes.pal' },
    { emoji: '🌍', key: 'nav.causes.west' },
    { emoji: '🕌', key: 'nav.causes.min' },
    { emoji: '👩', key: 'nav.causes.women' },
  ];

  // Category name: use language-appropriate field
  const catName = (c) => {
    if (!c) return '';
    if (lang === 'ar') return c.name_ar || '';
    if (c.translations && c.translations[lang] && c.translations[lang].name) {
      return c.translations[lang].name;
    }
    if (lang === 'en') return c.name_en || c.name_ar || '';
    return c.name_ar || '';
  };

  return (
    <nav className="main-nav">
      <div className="nav-inner">

        <div className="nav-item">
          <a href="/" className={at('/')} onClick={go('/')}>{t('nav.home')}</a>
        </div>

        <div className="nav-item">
          <button className={at('/fatwas')} onClick={() => navigate('/fatwas')}>
            {t('nav.fatwa')} <span className="nav-chevron">▾</span>
          </button>
          <div className="nav-drop">
            <a href="/fatwas" onClick={go('/fatwas')}>{t('nav.fatwa.all')}</a>
            {categories.map(c => (
              <a key={c.id} href={`/fatwas?cat=${c.id}`}
                onClick={e => { e.preventDefault(); navigate(`/fatwas?cat=${c.id}`); }}>
                {catName(c)}
              </a>
            ))}
          </div>
        </div>

        {false && (
        <div className="nav-item">
          <button className={at('/causes')} onClick={() => navigate('/causes')}>
            {t('nav.causes')}
            <span className="nbadge red">{newBadge[lang] || newBadge.ar}</span>
            <span className="nav-chevron">▾</span>
          </button>
          <div className="nav-drop">
            {causesItems.map(item => (
              <a key={item.key} href="/causes" onClick={go('/causes')}>
                {item.emoji} {t(item.key)}
              </a>
            ))}
          </div>
        </div>
        )}

        {false && (
        <div className="nav-item">
          <button className={at('/youth')} onClick={() => navigate('/youth')}>
            {t('nav.youth')} <span className="nbadge amber">🔥</span> <span className="nav-chevron">▾</span>
          </button>
          <div className="nav-drop" />
        </div>
        )}

        <div className="nav-item">
          <button className={at('/articles')} onClick={() => navigate('/articles')}>
            {t('nav.articles')} <span className="nav-chevron">▾</span>
          </button>
          <div className="nav-drop">
            <a href="/articles" onClick={go('/articles')}>{t('nav.articles.all')}</a>
          </div>
        </div>

        <div className="nav-item">
          <a href="/lectures" className={at('/lectures')} onClick={go('/lectures')}>{t('nav.lectures')}</a>
        </div>

        <div className="nav-item">
          <a href="/research" className={at('/research')} onClick={go('/research')}>{t('nav.research')}</a>
        </div>

        <div className="nav-item">
          <button className={at('/scholars')} onClick={() => navigate('/scholars')}>
            {t('nav.scholars')} <span className="nav-chevron">▾</span>
          </button>
          <div className="nav-drop">
            <a href="/scholars" onClick={go('/scholars')}>{t('nav.scholars.all')}</a>
            {scholars.map(s => (
              <a key={s.id} href={`/scholars/${s.id}`}
                onClick={e => { e.preventDefault(); navigate(`/scholars/${s.id}`); }}>
                {scholarTitledName(s.name, lang)}
              </a>
            ))}
          </div>
        </div>

        <div className="nav-item">
          <a href="/about" className={at('/about')} onClick={go('/about')}>{t('nav.about')}</a>
        </div>

      </div>
    </nav>
  );
}